export const SORTING_ICON_CLASS_NAME = 'view-mode-sorting-icon';
export const IS_DISABLED_CLASS_NAME = 'is-disabled';
export const SORT_INDEX_DATA_ATTRIBUTE = 'data-sort-index';
